import fullLogo from '../_Assets/Full_logo_TWB.svg';
import { useNavigate } from 'react-router-dom';

export default function AuthCard({ children, backTo }) {
  const navigate = useNavigate();
  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo-wrapper">
          <img src={fullLogo} alt="Membify" className="login-logo" />
        </div>
        {backTo && (
          <button className="back-btn" onClick={() => navigate(backTo)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 5l-7 7 7 7" />
            </svg>
            Tilbage
          </button>
        )}
        {children}
      </div>
    </div>
  );
}
